import type { MarlinStoreDb } from "../infra/db";
import { defaultScreen } from "../screens/store";

export const resetStore = async (
  db: MarlinStoreDb,
  screenIds: number[],
): Promise<{ cleared: number }> => {
  let cleared = 0;
  await db.transaction("rw", db.tables, async () => {
    for (const table of db.tables) {
      cleared += await table.count();
      await table.clear();
    }
    const seed = screenIds.length > 0 ? screenIds : [1];
    await db.screens.bulkAdd(seed.map(defaultScreen));
  });
  return { cleared };
};
